/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectModules.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 27-09-2024
 * @description : Provides list of module to select
 */
import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CustomSelectV2 from "../customComponentsV2/common/select/CustomSelectV2";

function SelectModules({
  selectedProjectDetails,
  selectedPaBtn,
  moduleTypes,
  variantOptionsList,
  selectedVariant,
  setSelectedVariant,
  zoneOptionsList,
  selectedZone,
  setSelectedZone,
  eeOptionsList,
  selectedEE,
  setSelectedEE,
  swmOptionsList,
  selectedSWM,
  setSelectedSWM,
  vehicleSystemOptionsList,
  selectedVehicleSystem,
  setSelectedVehicleSystem,
  vehicleComponentOptionsList,
  selectedVehicleComponent,
  setSelectedVehicleComponent,
}) {
  return (
    <Stack spacing={2} mt={2}>
      {(selectedPaBtn === moduleTypes?.VARIANT ||
        selectedPaBtn === moduleTypes?.ZONE ||
        selectedPaBtn === moduleTypes?.EE ||
        selectedPaBtn === moduleTypes?.SWM ||
        selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM ||
        selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT) && (
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: "0.9rem",
                mb: 0.5,
              }}
              textAlign={"start"}
            >
              Variant:
            </Typography>

            <Box sx={{ width: "100%" }}>
              <CustomSelectV2
                showlabelNew={false}
                label="Variant"
                enableSearch={true}
                optionsList={variantOptionsList}
                selectedValue={selectedVariant}
                sltFldStyle={{
                  minHeight: "45px",
                  fontSize: "0.95rem",
                  borderRadius: 0,
                }}
                handleOnChange={(e) => setSelectedVariant(e.target.value)}
              />
            </Box>
          </Box>
        )}

      {(selectedPaBtn === moduleTypes?.ZONE ||
        selectedPaBtn === moduleTypes?.EE ||
        selectedPaBtn === moduleTypes?.SWM ||
        selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM ||
        selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT) &&
        selectedProjectDetails?.is_zonal && (
          <Box sx={styles.fieldContainer}>
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: "0.9rem",
                mb: 0.5,
              }}
              textAlign={"start"}
            >
              Zone:
            </Typography>

            <Box sx={{ width: "100%" }}>
              <CustomSelectV2
                showlabelNew={false}
                label="Zone"
                enableSearch={true}
                optionsList={zoneOptionsList || []}
                selectedValue={selectedZone}
                sltFldStyle={{
                  minHeight: "45px",
                  fontSize: "0.95rem",
                  borderRadius: 0,
                }}
                handleOnChange={(e) => setSelectedZone(e.target.value)}
              />
            </Box>
          </Box>
        )}

      {(selectedPaBtn === moduleTypes?.EE ||
        selectedPaBtn === moduleTypes?.SWM) && (
          <Box sx={styles.fieldContainer}>

            <Typography
              sx={{
                color: "text.secondary",
                fontSize: "0.9rem",
                mb: 0.5,
              }}
              textAlign={"start"}
            >
              EE Component:
            </Typography>
            <Box sx={{ width: "100%" }}>
              <CustomSelectV2
                showlabelNew={false}
                label="EE"
                enableSearch={true}
                optionsList={eeOptionsList || []}
                selectedValue={selectedEE}
                sltFldStyle={{
                  minHeight: "45px",
                  fontSize: "0.95rem",
                  borderRadius: 0,
                }}
                handleOnChange={(e) => setSelectedEE(e.target.value)}
              />
            </Box>
          </Box>
        )}

      {selectedPaBtn === moduleTypes?.SWM && (
        <Box sx={styles.fieldContainer}>

          <Typography
            sx={{
              color: "text.secondary",
              fontSize: "0.9rem",
              mb: 0.5,
            }}
            textAlign={"start"}
          >
            Software Module:
          </Typography>

          <Box sx={{ width: "100%" }}>
            <CustomSelectV2
              showlabelNew={false}
              label="SWM"
              enableSearch={true}
              optionsList={swmOptionsList || []}
              selectedValue={selectedSWM}
              sltFldStyle={{
                minHeight: "45px",
                fontSize: "0.95rem",
                borderRadius: 0,
              }}
              handleOnChange={(e) => setSelectedSWM(e.target.value)}
            />
          </Box>
        </Box>
      )}

      {(selectedPaBtn === moduleTypes?.VEHICLE_SYSTEM ||
        selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT) && (
          <Box sx={styles.fieldContainer}>

            <Typography
              sx={{
                color: "text.secondary",
                fontSize: "0.9rem",
                mb: 0.5,
              }}
              textAlign={"start"}
            >
              Vehicle System:
            </Typography>

            <Box sx={{ width: "100%" }}>
              <CustomSelectV2
                showlabelNew={false}
                label="Vehicle System"
                enableSearch={true}
                optionsList={vehicleSystemOptionsList || []}
                selectedValue={selectedVehicleSystem}
                sltFldStyle={{
                  minHeight: "45px",
                  fontSize: "0.95rem",
                  borderRadius: 0,
                }}
                handleOnChange={(e) => setSelectedVehicleSystem(e.target.value)}
              />
            </Box>
          </Box>
        )}

      {selectedPaBtn === moduleTypes?.VEHICLE_COMPONENT && (
        <Box sx={styles.fieldContainer}>

          <Typography
            sx={{
              color: "text.secondary",
              fontSize: "0.9rem",
              mb: 0.5,
            }}
            textAlign={"start"}
          >
            Vehicle Component:
          </Typography>

          <Box sx={{ width: "100%" }}>
            <CustomSelectV2
              showlabelNew={false}
              label="Vehicle Component"
              enableSearch={true}
              optionsList={vehicleComponentOptionsList || []}
              selectedValue={selectedVehicleComponent}
              sltFldStyle={{
                minHeight: "45px",
                fontSize: "0.95rem",
                borderRadius: 0,
              }}
              handleOnChange={(e) =>
                setSelectedVehicleComponent(e.target.value)
              }
            />
          </Box>
        </Box>
      )}
    </Stack>
  );
}

export default SelectModules;

// Styles
const styles = {
  detailsContainer: {
    minWidth: "100%",
    border: "1px solid black",
    px: 2,
    pt: 0.4,
    pb: 2,
    my: 2,
  },
  nrDetailsTxt: {
    textAlign: "start",
  },
  txtBold: {
    fontWeight: "bold",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  divider: {
    mt: 0.4,
    mb: 1,
  },
  searchSelectTextField: {
    width: "100%",
    "& .MuiInputBase-input": {
      fontSize: "15px",
    },
  },
};
